<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_system_roles'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-show="userData.permissions['new_system_role'] == 1" v-b-modal.new-role size="sm"
                variant="primary"><i class="mdi mdi-plus"></i> New Role</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button v-show="userData.permissions['edit_system_role'] == 1"
                      @click="edit(data.item.id, data.item.name)" type="button" class="btn-sm btn" variant="primary"
                      v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                    <b-button v-show="userData.permissions['delete_system_role'] == 1"
                      @click="remove(data.item.id, data.item.name)" type="button" class="btn-sm btn" variant="danger"
                      v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view System Roles</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-role" centered title="New System Role" title-class="font-18" hide-footer>
      <form @submit.prevent="addRole">
        <div class="form-group mb-2">
          <label>Name</label>
          <input v-model="name" type="text" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-role')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-role" centered title="Edit System Role" title-class="font-14" hide-footer>
      <form @submit.prevent="editRole">
        <div class="form-group mb-2">
          <input v-model="id" type="hidden">
          <label>Role Name</label>
          <input v-model="name" type="text" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-role')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-role" centered title="Delete System Role" title-class="font-18" hide-footer>
      <form @submit.prevent="removeRole">
        <input v-model="id" type="hidden">
        Are you sure you want to delete the Role : <b>{{ name }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-role')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { roleMethods, roleComputed } from "@/state/helpers";

export default {
  page: {
    title: "System Roles",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Roles",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Roles", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'name', label: 'Name', visible: true },
        { key: 'addedby', label: 'Added by', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      name: '',
    };
  },
  computed: {
    ...roleComputed,
    List() { return this.roles.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.roles.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.roles.length > 0) { a = false; } else { a = true; } return a },
  },
  mounted() {
    this.fetchRoles();
    this.TotalRows = this.roles.length;
    this.isBusy = false;
  },
  methods: {
    ...roleMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show('edit-role')
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show('delete-role')
    },
    async addRole() {
      let formData = new FormData();
      formData.append("name", this.name);
      let url = "/addsystemrole";
      axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRoles();
          this.$bvModal.hide('new-role');
          this.name = "";

          this.$toast.success("New System Role Added");
        } else {
          this.$toast.error(response?.data?.message || response?.data?.error || "An error occurred");
        }
      }).catch((error) => {
        this.$toast.error(error?.response?.data?.message || error?.response?.data?.error || "An error occurred");
      });
    },
    async editRole() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      let url = "/updatesystemrole";
      axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRoles();
          this.$bvModal.hide('edit-role');
          this.name = "";
          this.$toast.success("System Role Updated");
        } else {
          this.$toast.error(response?.data?.message || response?.data?.error || "An error occurred");
        }
      }).catch((error) => {
        this.$toast.error(error?.response?.data?.message || error?.response?.data?.error || "An error occurred");
      });
    },
    async removeRole() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesystemrole";
      axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRoles();
          this.$bvModal.hide('delete-role');
          this.$toast.success("System Role Deleted");
          this.name = "";
        } else {
          this.$toast.error(response?.data?.message || response?.data?.error || "An error occurred");
        }
      }).catch((error) => {
        this.$toast.error(error?.response?.data?.message || error?.response?.data?.error || "An error occurred");
      });
    },
  },
};
</script>